import { SystemImage } from '@cms/components/data/Image';
import { renderAttribute } from '@cms/components/renders';
import { TEAM_OPTIONS } from '@cms/utils/constants';
import { generateSearchParam, mapLookupsToOptions } from '@cms/utils/helpers';
import { rolesLookupsQuery } from '@cms/utils/queries';
import { ISystemUser, STATUSES } from '@dl/declarations';
import clsx from 'clsx';
import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { UserForm } from '../../components/forms/UserForm';
import { DataPart } from '../../components/ui/DataPart';
import PageContainer from '../../components/ui/PageContainer';
import { renderRouteOptions, Routes, UsersPath } from '../../utils/routes';


const UsersPage = () => {
    const { data: roles } = rolesLookupsQuery({}, { fetchOnce: true })

    const renderItem = useCallback((item: ISystemUser) => {
        return (
            <Link
                className={clsx(
                    'py-4 ps-4 pe-12 w-full',
                    'grid grid-cols-8 items-center gap-2',
                    'border border-cs-700 rounded-md',
                )}
                to={{
                    pathname: Routes.USERS,
                    search: `?${generateSearchParam(UsersPath, "mode", "update")}&${generateSearchParam(UsersPath, "id", item._id)}`,
                }}
                key={item._id}
            >
                <SystemImage
                    src={item.imageObject?.src_url}
                    alt={item.name}
                    className='w-24 h-auto min-h-24 object-cover'
                />

                <h4 className='w-full col-span-2 text-cs-600 font-semibold'>
                    {item.name}
                </h4>

                {renderAttribute({
                    title: {
                        value: 'Team',
                    },
                    value: {
                        value: [item.team],
                        className: 'font-bold'
                    }
                })}

                {renderAttribute({
                    title: {
                        value: 'Role',
                    },
                    value: {
                        value: [item.title],
                        className: 'font-bold'
                    }
                }, {
                    className: 'col-span-2'
                })}

                {renderAttribute({
                    title: {
                        value: 'Permissions',
                    },
                    value: {
                        value: [item.customRoleObject?.name || 'N/A'],
                        className: 'font-bold'
                    }
                })}

                {/* {renderAttribute({
                    title: { value: 'Last login' },
                    value: {
                        value: [renderDateTime(item.last_login)],
                        component: (
                            renderDateTime(item.last_login)
                        )
                    }
                })} */}
            </Link>
        )
    }, [])

    return (
        <PageContainer
            title={renderRouteOptions(Routes.USERS).title}
        >
            <DataPart<ISystemUser>
                tableSize='full'

                distribution={{
                    type: 'grid',
                    renderItem: renderItem,
                    noOfColumns: "1"
                }}

                queryOptions={{
                    basePath: UsersPath,
                }}

                filters={{
                    team: {
                        searchOptions: {
                            allow: false,
                        },
                        options: TEAM_OPTIONS,
                        type: 'select',
                        label: 'Team',
                        allowMultiSelect: true,
                    },
                    custom_role: {
                        searchOptions: {
                            allow: false,
                        },
                        options: mapLookupsToOptions(roles || [], 'name', () => 'role'),
                        type: 'select',
                        label: 'Role',
                        allowMultiSelect: true,
                    },
                    is_active: {
                        searchOptions: {
                            allow: false,
                        },
                        options: [
                            { _id: STATUSES.ACTIVE, label: 'Active', slug: 'true', groupKey: 'Status' },
                            { _id: STATUSES.INACTIVE, label: 'Inactive', slug: 'false', groupKey: 'Status' }
                        ],
                        type: 'select',
                        label: 'Status',
                        allowMultiSelect: false
                    }
                }}

                updateOptions={{
                    allow: true,
                    hide: true
                }}
                createOptions={{
                    allow: true
                }}
                searchOptions={{
                    allow: true
                }}

                form={<UserForm />}
            />
        </PageContainer>
    )
}

export default UsersPage